import React from "react";
import Navbar from "../components/Navbar";
// import "../assets/Home.css";

const Home = () => {
  return (
    <>
      <Navbar />
      <div className="home-container">
        {/* Add content here if needed */}
      </div>
    </>
  );
};

export default Home;
